import { TypePolicies } from '@apollo/client';

export const typePolicies: TypePolicies = {
  Product: {
    fields: {
      tailoringProcess: {
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming);
        },
      },
    },
  },
  YesNoQuestion: {
    // due to neo4j returning same idså
    // we need to tell apollo how to identify the objects for caching
    keyFields: ['id', 'productId', 'updatedAfterLastInteraction'],
  },
  ProductBuildingBlock: {
    // due to neo4j returning same ids
    // we need to tell apollo how to identify the objects for caching
    keyFields: ['id', 'productId'],
  },
  ProductDataBlock: {
    // ProductDataBlock.id is the process-model node id (e.g. "DB_001") and is identical across products,
    // while fields like inclusion and assignedMaturityLevel are product-specific. Normalizing by id would
    // let one product's data overwrite another's, so embed data blocks in their (product-keyed) parent.
    keyFields: false,
  },
  ConfigurationGroup: {
    keyFields: ['id', 'productId'],
  },
  UniversalDesignObligation: {
    keyFields: false,
  },
  UniversalBuSpecificContent: {
    keyFields: false,
  },
  UniversalBuildingBlock: {
    keyFields: false,
  },
  UniversalDataBlock: {
    keyFields: false,
  },
  UniversalTailoringCriterion: {
    keyFields: false,
  },
  UniversalMaturityStage: {
    keyFields: false,
  },
  UniversalMaturityLevelSet: {
    keyFields: false,
  },
  UniversalMaturityLevelSequence: {
    keyFields: false,
  },
  UniversalCompetency: {
    keyFields: false,
  },
  UniversalInformation: {
    keyFields: false,
  },
  UniversalConfigurationGroup: {
    keyFields: false,
  },
  UniversalOperator: {
    keyFields: false,
  },
  ApplicationUserGroup: {
    keyFields: false,
  },
  BusinessUnit: {
    keyFields: false,
  },
};
